export default defineNuxtRouteMiddleware(() => {
  const { data: $auth } = useAuth();

  if (!Boolean($auth.value?.isWalletAvailable || $auth.value?.isPaypalWalletEnabled)) {
    return navigateTo('/');
  }
});
